import React from "react";
import Input from "components/Input/index";
import Select from "components/Select/index";
import RadioLabelComponent from "components/Toggles/RadioLabelComponent";
import MultiSelectSearch from "components/MultiSelectSearch/index";
import { CurrencyInrIcon } from "@phosphor-icons/react";
import { Label } from "components/Input/styled";
import { EditCreatorFormWrapperStyles } from "../styled";
import { barterTypeOptions, paymentTermOptions } from "pages/Creators/data";

const COST_FIELDS = [
  { id: "ig_image_cost", label: "Instagram Image Cost" },
  { id: "ig_reels_cost", label: "Instagram Reel Cost" },
  { id: "ig_story_cost", label: "Instagram Story Cost" },
  { id: "yt_video_cost", label: "YouTube Video Cost" },
  { id: "yt_shorts_cost", label: "YouTube Shorts Cost" }
];

const YesNoRadio = ({ label, fieldKey, form, setForm }) => (
  <div className="radio-input-wrapper">
    <Label as="p" size="M">
      {label}
    </Label>
    <div className="radio-input-group">
      <label className="radio-input-item">
        {["yes", "no"].map((option) => (
          <RadioLabelComponent
            key={option}
            labelHeader={option.charAt(0).toUpperCase() + option.slice(1)}
            checked={form[fieldKey] === option}
            onChange={() =>
              setForm((prev) => ({ ...prev, [fieldKey]: option }))
            }
          />
        ))}
      </label>
    </div>
  </div>
);

export const CreatorCommercialsSection = ({
  form,
  setForm,
  handleChange,
  data
}) => {
  return (
    <EditCreatorFormWrapperStyles>
      <div className="form-header-wrapper">
        <h2 className="title">Creator Commercials</h2>
      </div>

      <div className="form-content-wrapper">
        <div className="row-group">
          {/* ── Cost fields ── */}
          <div className="column-group">
            {COST_FIELDS.map(({ id, label }) => (
              <Input
                key={id}
                leftIcon={<CurrencyInrIcon weight="regular" color="#A5A5A5" />}
                id={id}
                label={label}
                placeholder="Enter Cost"
                value={form[id] || ""}
                onChange={handleChange}
                type="number"
                size="M"
              />
            ))}
          </div>

          {/* ── Availability & preferences ── */}
          <div className="column-group">
            <Select
              id="payment_term"
              label="Payment Terms"
              value={form.payment_term || ""}
              onChange={(value) =>
                setForm((prev) => ({ ...prev, payment_term: value }))
              }
              placeholder="Select Payment Term"
              options={paymentTermOptions}
            />

            <YesNoRadio
              label="Event Availability"
              fieldKey="event_availability"
              form={form}
              setForm={setForm}
            />

            <YesNoRadio
              label="Can post for betting apps"
              fieldKey="can_post_for_betting_apps"
              form={form}
              setForm={setForm}
            />

            <YesNoRadio
              label="Barter Availability"
              fieldKey="barter_availability"
              form={form}
              setForm={setForm}
            />

            {form.barter_availability !== "no" && (
              <MultiSelectSearch
                id="barter_preferences"
                label="Barter Type"
                options={barterTypeOptions}
                value={form.barter_preferences || []}
                onChange={(val) =>
                  setForm((prev) => ({ ...prev, barter_preferences: val }))
                }
                placeholder="Select Barter Type"
                disabled={data?.barter_preferences?.key === "no_profile"}
                hasWarn={
                  data?.barter_preferences?.key !== "no_profile" &&
                  !!data?.barter_preferences?.message &&
                  form.barter_preferences?.length === 0
                }
                errorText={
                  data?.barter_preferences?.key === "no_profile"
                    ? data?.barter_preferences?.message
                    : undefined
                }
              />
            )}
          </div>
        </div>
      </div>
    </EditCreatorFormWrapperStyles>
  );
};
